import styles from './CartItemSettings.module.scss'
import Checkbox from '@/components/inputs/Checkbox/Checkbox'
import { CartRowModel, CartRowOptionModel, KitsetType } from '@/types/api'
import useCartRow from '@/utils/hooks/useCartRow'
import { useTranslation } from 'next-i18next'
import React from 'react'
import usePrice from '@/utils/hooks/usePrice'
import IconLink from '@/components/common/IconLink/IconLink'
import ArticleShortcut from '@/assets/svg/article-shortcut.svg'
import Tooltip from '@mui/material/Tooltip'
import InfoIcon from '@/assets/svg/info.svg'

type Props = {
  item: CartRowModel
}

type ItemProps = {
  option: CartRowOptionModel
  onUpdate: (optionId: number, valueId: number) => void,
}

const CartItemSettingItem = (props: ItemProps) => {
  const { t } = useTranslation()
  const { price } = usePrice()

  return (
    <div className={styles.row}>
      <label>
        {t(props.option.translation)}
        {props.option.infoTranslation && (
          <Tooltip title={t(props.option.infoTranslation)} placement="top" arrow>
            <span className={styles.infoIcon}>
              <InfoIcon />
            </span>
          </Tooltip>
        )}
      </label>
      <div className={styles.options}>
        {
          props.option.values.map(value => {
            let label: string

            if (value.price) {
              const quantity = value.quantityPerPackage > 1 ? ` ${value.quantityPerPackage}` : '/'
              label = `${t(value.translation)} (${price(value.price)}${quantity}${t('common:pieceABBR')})`
            } else
              label = `${t(value.translation)}`

            return (
              <div key={value.id} className={styles.valueContainer}>
                <Tooltip
                  title={value.infoTranslation ? t(value.infoTranslation) : ''}
                  placement="top"
                  arrow
                  disableHoverListener={!value.infoTranslation}
                  slotProps={{
                    tooltip: {
                      sx: {
                        fontSize: '14px',
                      },
                    },
                  }}
                >
                  <div className={styles.valueRow}>
                    <div className={styles.optionWrapper}>
                      <Checkbox
                        label={label}
                        name={`${value.id}`}
                        checked={value.id === props.option.selectedValue}
                        onChange={() => props.onUpdate(props.option.id, value.id)}
                        disabled={props.option.locked}
                      />
                      <span className={styles.infoIcon}>
                        {value.infoTranslation && <InfoIcon />}
                      </span>
                    </div>
                  </div>
                </Tooltip>
                {value.link &&
                  <IconLink
                    href={value.link}
                    label={t('cart:showProduct')}
                    icon={ArticleShortcut}
                  />
                }
              </div>
            )
          })
        }
      </div>
    </div>
  )
}

const CartItemSettings = ({
  item
}: Props) => {
  const {
    updateOption
  } = useCartRow(item)

  return (
    <div className={styles.component}>
      {item.options?.map(option => (
        <CartItemSettingItem
          key={option.id}
          option={option}
          onUpdate={updateOption}
        />
      ))}
    </div>
  )
}

export default CartItemSettings